export const layoutConst = {
  // above this screen size, we can always keep the sidebar open
  // and it will never clip over the page contens
  XL_SCREEN_SIZE: 1300,
  SIDEBAR_WIDTH: 300,
  SIDEBAR_BREAKPOINT: 800,
  HEADER_HEIGHT: 80,
};
